export enum Module {
    Debug = 'Debug',
    Sections = 'Sections',
    Medicine = 'Medicine',
    Assignments = 'Assignments',
    UserManagement = 'UserManagement',
    RawMaterialsRegister = 'RawMaterialsRegister',
    StatusEntries = 'StatusEntries',
    BonusPayments = 'BonusPayments',
    PriceListings = 'PriceListings',
    RealTime = 'RealTime',
    DataQualityAssessment = 'DataQualityAssessment',
    Analysis = 'Analysis',
    HelpWidget = 'HelpWidget',
    RealtimeOnly = 'RealtimeOnly',
    // Temporary: gates the Active Groups and Group Overview pages. Remove when production groups go generally
    // available, together with the API's module and its TemporaryModuleContributor entry, and drop requiresModule
    // from the ActiveGroups, ActiveGroupsDetail and GroupOverview routes (the Monitoring parent still requires RealTime).
    ProductionGroup = 'ProductionGroup',
    Hitlist = 'Hitlist',
    // Temporary (KS-1941): gates the medicine stock beta (Health > Stock). Remove with the beta, together with the API's
    // module and setting it in TemporaryModuleContributor, and set the inventory routes' requiresModule back to Medicine.
    MedicineInventoryBeta = 'MedicineInventoryBeta',
    // Temporary: gates the week overview beta (Overview > Week overview) for non-admins; solution admins always see it. Remove with the beta, together
    // with the API's module and setting it in TemporaryModuleContributor, and set the route back to solution-admin only.
    WeekOverviewBeta = 'WeekOverviewBeta',
}
